import React, {Component, ReactNode} from 'react';
import styled from 'styled-components';

import {FlexSpacer} from '../../../common/flex';
import {FormattingMoreDropdownButton} from './formattingMoreDropdownButton';

/*
 * Props.
 */

interface FormattingMarkdownToolbarProps {
  isVisible?: boolean;
  renderMoreDropdownItems?: () => ReactNode;
}

/*
 * Style.
 */

const StyledFormattingDiv = styled.div`
  display: flex;
  align-items: center;

  min-height: 51px;
  padding: 0 8px;

  border-top: 1px solid ${(p) => p.theme.greys.shade30};
  background-color: ${(p) => p.theme.foreground};
`;

const StyledHintsList = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  color: ${(p) => p.theme.greys.shade60};

  li {
    list-style-type: none;
    margin: 0 10px;
  }
`;

/*
 * Component.
 */

// TODO: Refactor duplication with FormattingToolbar.
export class FormattingMarkdownToolbar extends Component<FormattingMarkdownToolbarProps> {
  render() {
    const {isVisible, renderMoreDropdownItems} = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <StyledFormattingDiv>
        <StyledHintsList>
          <li>
            <b>**bold**</b>
          </li>
          <li>
            <i>*italics*</i>
          </li>
          <li>
            <s>~~strike~~</s>
          </li>
          <li>&gt; quote</li>
          <li>[link](frontapp.com)</li>
        </StyledHintsList>
        <FlexSpacer />
        {renderMoreDropdownItems && (
          <FormattingMoreDropdownButton>{renderMoreDropdownItems()}</FormattingMoreDropdownButton>
        )}
      </StyledFormattingDiv>
    );
  }
}
